export type KeyDataSearch =
  | 'number_of_adults'
  | 'number_of_preschoolers'
  | 'number_of_students'
  | 'number_of_preschoolers_1'
  | 'number_of_students_1'
  | 'number_of_study_abroad'
  | 'stay_day'
  | 'start_date'
  | 'birthdays'

export type ChildBirthday = {
  year: string
  month: string
  day: string
}

export type DataSearchType = {
  number_of_adults: number
  number_of_preschoolers: number
  number_of_students: number
  number_of_preschoolers_1: number
  number_of_students_1: number
  number_of_study_abroad: number
  birthdays: ChildBirthday[]
  stay_day: string
  start_date: string
  select_month: string
}

export const serviceTypes = JSON.parse(
  (document.querySelector('[data-service-types]') as HTMLElement)?.dataset?.serviceTypes || '[]',
) as string[]

export const DATA_SEARCH_INIT: DataSearchType = {
  number_of_adults: 2,
  number_of_preschoolers: 1,
  number_of_students: 0,
  number_of_preschoolers_1: 0,
  number_of_students_1: 0,
  number_of_study_abroad: 1,
  birthdays: [{ year: '', month: '', day: '' }],
  stay_day: '7',
  start_date: undefined,
  select_month: undefined,
}

export const searchData: DataSearchType = {
  ...DATA_SEARCH_INIT,
}

export type RoomType = {
  id: number
  name: string
  roomType: string
  description: string | null
  roomMaxCount: number
  adultMaxCount: number
  // [issue#2291] 予約リクエスト確認モーダルの定員チェックで使用する
  childrenMaxCount: number
  kitchen: string | null
  bedroom: string | null
  bathroom: string | null
  laundry: string | null
  food: string | null
  roomEnvironment: string
  accessFromGuestHouseToNursery: string | null
  accessToNursery: string | null
  conditionsForRemoteWork: string | null
  photos: { url: string; caption: string }[]
  floorImages: string[]
  order: number | null
}

export type CheckInDateType = {
  id: number | null
  date: string // ISO date format (YYYY-MM-DD)
  endDate: string
  status: 'OK' | 'NG' | '-'
  price: number | null
  stayDay: number
}

export type PlanType = {
  planId: number
  subPlanName: string | null
  mainNurseryName: string
  mainNurseryFirstFeatureImageUrl: string
  subNurseryName: string | null
  subNurseryFirstFeatureImageUrl: string | null
  // [FB-76] 部屋なしプラン（宿泊なし / School Fee Only）は JSON に room キーを持たないため optional。
  room?: RoomType | null
  roomDisplayOrder: number | null
  checkInDates: CheckInDateType[]
}
